<template>
  <div class="fx mt-24 map-wrap">
    <div class="el-card p-16 mr-24 fx-full charts-map">
      <MyTitle class="mb-16">
        产业链图谱
        <div slot="right">
          <div class="fx fx-s-center">
            <div class="mode-1" :class="{'actived':radioType==1}" @click="tHandle(1)"></div>
            <div class="ml-8 mr-8" style="color: #b6bed0;">|</div>
            <div class="mode-2" :class="{'actived':radioType==2}" @click="tHandle(2)"></div>
          </div>
        </div>
      </MyTitle>
      <div class="charts-tree">
        <div v-show="radioType==1" ref="container" key="tree1" class="tree1"></div>
        <div v-show="radioType==2" class="stream-box tree-map" ref="box" key="tree2">
          <div class="stream" v-for="(stream,i) in industry" :key="i">
            <div class="type type1" :class="`type${i+1}`">{{['上','中','下'][i]}}游</div>
            <el-card class="item-card" v-for="(item,j) in stream" :key="j">
              <div slot="header" style="position: relative;width: 100%;" :ref="item.nodeCode" :class="item.nodeCode">{{item.nodeName}}</div>
              <div>
                <el-tree :data="item.children" :props="defaultProps" @node-click="handleNodeClick">
                  <span slot-scope="{ node, data }" class="custom-tree-node">
                    <span>{{ node.label }}</span>
                  </span>
                </el-tree>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </div>
    <div class="el-card p-16 fx-none charts-wrap">
      <MyTitle class="mb-16">
        产业发展趋势
        <div slot="right" @click="goPageClick('analyze')">查看更多产业分析</div>
      </MyTitle>
      <div class="charts-list">
        <MyEcharts ref="chartFirst" class="h300" />
        <MyEcharts ref="chartFirst4" class="h300" />
        <MyEcharts ref="chartFirst7" class="h300" />
        <MyEcharts ref="chartFirst10" class="h300" />
      </div>
    </div>
  </div>
</template>

<script>
import MyTitle from '@/views/industryChainNew/components/myTitle'
import MyEcharts from '@/components/myEcharts'
import { D3Tree, StreamsTree, D3Path } from '@/components/D3Tree'
import { levelTwo, companyCountChart, smallPieChart, barChart, pieChart, lineChart } from '../components/echartsOptions'
import { getChainTopCompany, getChainAnalysis, getIndustryChain } from '@/views/industryChainNew/api'
import { mapState } from 'vuex'

export default {
  name: 'IndustryMap',
  components: {
    MyTitle, MyEcharts
  },
  props: {

  },
  data() {
    return {
      radioType: '1',
      data: [{
        label: '一级 1',
        children: [{
          label: '二级 1-1',
          children: [{
            label: '三级 1-1-1'
          }]
        }]
      }, {
        label: '一级 2',
        children: [{
          label: '二级 2-1',
          children: [{
            label: '三级 2-1-1'
          }]
        }, {
          label: '二级 2-2',
          children: [{
            label: '三级 2-2-1'
          }]
        }]
      }, {
        label: '一级 3',
        children: [{
          label: '二级 3-1',
          children: [{
            label: '三级 3-1-1'
          }]
        }, {
          label: '二级 3-2',
          children: [{
            label: '三级 3-2-1'
          }]
        }]
      }],
      defaultProps: {
        children: 'children',
        label: 'nodeName'
      },
      industry: [],
      analysis: {}
    }
  },
  computed: {
    ...mapState({
      chainIDMap: state => state.asyncRoute.chainIDMap,
    }),
    ID() {
      return this.$route?.query?.id
    }
  },
  mounted() {
    this.getIndustryChain()
    this.getChainAnalysis()
  },
  methods: {
    goPageClick(activeName) {
      this.$router.push({ path: `/zxk/industryChain/${activeName}`, query: this.$route.query })
    },
    async getIndustryChain() {
      const [err, res] = await this.$reqFn(getIndustryChain, {
        "isPart": 0,
        "productNodeCode": "",
        secId: this.ID
      })
      if (res && res.code === 200) {
        const { upStreams, middleStreams, downStreams } = res.data || {}
        this.industry = [upStreams || [], middleStreams || [], downStreams || []]

        const tree = new D3Tree(this.$refs.container)
        tree.create({
          nodeName: this.chainIDMap[this.ID].secName,
          children: [...res.data.upStreams, ...res.data.middleStreams, ...res.data.downStreams]
        })
      }
    },

    async tHandle(val) {
      this.radioType = val
      if (this.radioType == 1) return
      if (this.d3Path) return
      await this.$nextTick()
      this.d3Path = new D3Path(this.$refs.box)
      const [upStreams, middleStreams, downStreams] = this.industry

      const upStreamsP = []
      const middleStreamsP = []
      const downStreamsP = []
      upStreams.forEach(e => upStreamsP.push(e))
      middleStreams.forEach(e => middleStreamsP.push(e))
      downStreams.forEach(e => downStreamsP.push(e))

      const upToMid = []
      const midToDown = []
      await this.$nextTick()
      upStreamsP.forEach(u => {
        middleStreams.forEach(m => {
          upToMid.push({ start: this.$refs[u.nodeCode][0], end: this.$refs[m.nodeCode][0] })
        })
      })
      middleStreams.forEach(m => {
        downStreams.forEach(d => {
          midToDown.push({ start: this.$refs[m.nodeCode][0], end: this.$refs[d.nodeCode][0] })
        })
      })


      this.d3Path.create([
        ...upToMid,
        ...midToDown,
      ])
    },
    async getChainAnalysis() {
      const [err, res] = await this.$reqFn(getChainAnalysis, {
        secId: this.ID,
      })
      if (res && res.code === 200) {
        this.analysis = res.data || {}
        this.initCharts()
      }
    },
    initCharts() {
      const {
        companyCount, yearsStatistical,
        regCapitalStatistics, pevcTrendList, takingTrend, grossProfitMargin, technologyTrends,
        patentTypesDistribution, qualCompanyStatistical
      } = this.analysis

      this.$refs.chartFirst.update(companyCountChart(companyCount))
      this.$refs.chartFirst4.update(levelTwo(takingTrend, ['全国产品线营业收入', '全国产品线营业收入增速'], '营业收入趋势'))

      let pieChartData
      for (let index = pevcTrendList.length - 1; index > 0; index--) {
        pieChartData = pevcTrendList[index]
        if (pieChartData.detailList.length) break
      }

      this.$refs.chartFirst7.update(pieChart(pieChartData))

      this.$refs.chartFirst10.update(smallPieChart(qualCompanyStatistical, '资质企业统计'))
    },
    handleNodeClick(data) {
      console.log(data);
    }
  },
}
</script>

<style scoped lang="scss">
.charts-wrap {
  width: 450px;
  height: 720px;
  .charts-list {
    height: calc(100% - 35px);
    overflow-y: auto;
  }
}
.charts-map {
  height: 720px;
  .charts-tree {
    height: calc(100% - 35px);
    overflow-y: auto;
    .tree1{
      height: 100%;
    }
  }
}
.industry-chain-map .map-panel .tree-map {
}
::v-deep .stream-box {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: space-around;
  overflow: auto;
  position: relative;
  .stream {
    width: 260px;
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    position: static;
    z-index: 2;
    .type {
      width: 100%;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-size: contain;
      color: #fff;
      &.type1 {
        background: url("/static/image/d3tree/stream-1.png") 0 0 no-repeat;
      }
      &.type2 {
        background: url("/static/image/d3tree/stream-2.png") 0 0 no-repeat;
      }
      &.type3 {
        background: url("/static/image/d3tree/stream-3.png") 0 0 no-repeat;
      }
    }
    .item-card {
      border-radius: 4px;
      border: 1px solid #efefef;
      width: 100%;
      margin-top: 20px;
      .el-card__header {
        background: #f4f6f9;
        border: 0;
        padding: 10px 16px;
        display: flex;
        align-items: center;
        flex-flow: row nowrap;
        gap: 8px;
      }
      .el-card__body {
        padding: 0;
        height: 284px;
        overflow: auto;
      }
    }
  }
}

::v-deep {
  .el-tree .el-tree-node .el-tree-node__content {
    flex-direction: row-reverse;
    height: 36px;
    .custom-tree-node {
      padding-left: 16px;
      flex: 1;
      width: 0;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #555;
    }
  }
}

.map-wrap {
  align-items: flex-start;
}

.h300 {
  height: 300px;
}
.mode-1 {
  width: 20px;
  height: 20px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 0 0;
  background-image: url("~@/assets/industryChainNew/mode1.png");
  &:hover,
  &.actived {
    background-position: -20px 0;
  }
}
.mode-2 {
  width: 20px;
  height: 20px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 0px 0;
  background-image: url("~@/assets/industryChainNew/mode2.png");
  &:hover,
  &.actived {
    background-position: -20px 0;
  }
}
</style>
